module.exports = __webpack_public_path__ + "fonts/Chivo-Light.f2b6049.ttf";